import React from 'react';
import {getCurrentStyle} from "../../../helpers/passport";
import {GREEN_COLOR_JS, ORANGE_COLOR_PASSPORT} from "../../../utils/consts";
import TooltippedElement from "../../common/TooltippedElement";


const IndicatorsDataTable = ({data, type, sortedPcs,sortedAcceptedPcs,years}) => {

    //Создал пустые TD  для вставки в таблицу
    return (
        <React.Fragment>
            {!!sortedPcs.length  && <tr>
                <td style={{color:ORANGE_COLOR_PASSPORT}} colSpan={years?.length+3}>{type}</td>
            </tr>}
            {sortedPcs.map((p,index) => {
                const acceptedResultElement = sortedAcceptedPcs?.[index] ?? {};
                return(
                    <tr key={p.id}>
                        <td style={(()=> {
                            return getCurrentStyle(data.status,p,acceptedResultElement,'name')})()
                        }>{p.name}
                            {!!p.calcDescr && <TooltippedElement tooltip={p.calcDescr}></TooltippedElement>}
                        </td>
                        <td style={getCurrentStyle(data.status,p,acceptedResultElement,'unit')}>{p.unit}</td>
                        {years.map((year) => {
                            return <td style={getCurrentStyle(data.status,p,acceptedResultElement,`${year}`)} key={`${p.id}_${year}`}>{p[year] || '-'}</td>})}
                        <td style={getCurrentStyle(data.status,p,acceptedResultElement,'isKey')}>{p.isKey ? 'Да' : 'Нет'}</td>
                    </tr>
                )})}
        </React.Fragment>
    )
    // return(
    //     <tr key={indicator.id}>
    //         <td style={(()=> {
    //             return getCurrentStyle(data.status,indicator,acceptedIndicator,'name')})()
    //         }>{indicator.name}</td>
    //         <td style={getCurrentStyle(data.status,indicator,acceptedIndicator,'unit')}>{indicator.unit}</td>
    //         {years.map((year) => {
    //             return <td style={getCurrentStyle(data.status,indicator,acceptedIndicator,`${year}`)} key={`${indicator.id}_${year}`}>{indicator[year] || '-'}</td>})}
    //         <td style={getCurrentStyle(data.status,indicator,acceptedIndicator,'isKey')}>{indicator.isKey ? 'Да' : 'Нет'}</td>
    //     </tr>
    // )
    // );
};

export default IndicatorsDataTable;